import { createContext } from 'react';
import { KeyValueObject } from '../types/shared';

interface AuthContextProps {
  isLoggedin: boolean;
  csrf: string;
  invoices: boolean;
  cash: number;
  currency: string;
  location: string | undefined;
  reports: KeyValueObject<any>[];
  userCapabilities: string[];
  signOut: () => void;
  signIn: () => void;
}

export const authProviderInitValue = {
  isLoggedin: false,
  csrf: '',
  invoices: false,
  cash: 0,
  currency: 'USD',
  location: "am",
  reports: [],
  userCapabilities: [],
  signOut: () => { },
  signIn: () => { },
}

const AuthContext = createContext<AuthContextProps>(authProviderInitValue);

export const AuthProvider = AuthContext.Provider;

export default AuthContext;